import EncryptUtility from "../../utility/js/encrypt-utility.js";
import AddFavourite from "../../utility/js/addFav.js";
import breadcrumbComp from "../../common/breadcrumb-comp";
import usbServices from "./usb-services.js";
import Utility from "@/shared/utility.js";
import router from "../../../router/router";
import PrinterDetails from "../../common/printer-details";
export default {
  data() {
    return {
      refresh: true,
      backSlash: true,
      actionList: [],
      mainPage: "",
      subPage: "",
      pageUrl: "",
      favouriteList: [],
      showAdd: false,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      selectedProject: [],
      selectedBusiness: [],
      selectedCountry: [],
      selectedWorkflow: [],
      projectList: [],
      businessList: [],
      countryList: [],
      workflowList: [],
      showPrimary: true,
      printDisable: true,
      printerConfigured: false,
      configSourcingHeaders: [
        { text: "Workflow", value: "workflow", class: "primary customwhite--text" },
        { text: "Status", value: "status", class: "primary customwhite--text" },
        { text: "Project", value: "project", class: "primary customwhite--text" },
        { text: "RLP Order", value: "sono", class: "primary customwhite--text" },
        { text: "Customer ID", value: "TaskID", class: "primary customwhite--text" },
        { text: "Part Number", value: "part_num", class: "primary customwhite--text" },
        { text: "Location", value: "sh_country", class: "primary customwhite--text" },
        { text: "Sourcing Requested", value: "relativetime", class: "primary customwhite--text" },
        { text: "Progress", value: "progress", class: "primary customwhite--text" },
        { text: "Actions", value: "action", class: "primary customwhite--text" },
      ],
      configSourcingData: [],
      totalRecords: 0,
      searchRules: [(v) => !!v || "Search is required"],
      max50Rule: [(v) => (v || "").length <= 50 || "Max Length of 50 character", (v) => !!v || "Field is required"],
      search: "",
      lpnText: "",
      lpnNum: "",
      dropOffLPNDialog: false,
      userAssignedLPN: "",
      stagingLocationLPN: "",
      dropLPN: false,
      lpnKey: "",
      lineKeys: [],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    if (EncryptUtility.localStorageDecrypt("defaultName") !== null && EncryptUtility.localStorageDecrypt("defaultName") !== undefined) {
      this.printDisable = false;
      this.printerConfigured = false;
    } else {
      this.printDisable = true;
      this.printerConfigured = true;
      let Alert = {
        type: "error",
        isShow: true,
        message: "Default Printer is not configured, please configure printer",
      };
      this.$store.commit("ConfigModule/Alert", Alert);
    }
    this.getConfigurationDDL();
    this.sourceConfigLoadSourcedLine();
    this.getBreadCrumbLPN();
    this.getSearch();
    this.interval = setInterval(() => {
      this.getSearch();
    }, 120000);
  },
  destroyed() {
    clearInterval(this.interval);
  },
  mounted() {
    router.afterEach((to) => {
      if (!to.path.includes("configuration-sourcing-details") && !to.path.includes("configuration-sourcing")) {
        EncryptUtility.localStorageRemoveItem("CSProject");
        EncryptUtility.localStorageRemoveItem("CSProjectData");
        EncryptUtility.localStorageRemoveItem("CSBusiness");
        EncryptUtility.localStorageRemoveItem("CSBusinessData");
        EncryptUtility.localStorageRemoveItem("CSCountry");
        EncryptUtility.localStorageRemoveItem("CSCountryData");
        EncryptUtility.localStorageRemoveItem("CSWorkflow");
        EncryptUtility.localStorageRemoveItem("CSWorkflowData");
      }
    });
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.selectedProject = [];
      this.selectedBusiness = [];
      this.selectedCountry = [];
      this.selectedWorkflow = [];
      this.configSourcingData = [];
      this.totalRecords = 0;
      this.search = "";
      this.lpnText = "";
      this.lpnNum = "";
      this.dropOffLPNDialog = false;
      this.userAssignedLPN = "";
      this.stagingLocationLPN = "";
      this.dropLPN = false;
      this.lineKeys = [];
      this.$refs.configurationSourcing.resetValidation();
      this.getBreadCrumbLPN();
      this.getSearch();
    },
    async getConfigurationDDL() {
      let configSourcingDdl = await usbServices.getconfigSourcingDdl("get", this.userId);
      this.projectList = configSourcingDdl.project;
      this.businessList = configSourcingDdl.business;
      this.countryList = configSourcingDdl.country;
      this.workflowList = configSourcingDdl.workflow;
      this.search = "";
      this.$refs.configurationSourcing.resetValidation();
    },
    //Loading Local Storage items for search persistance
    getSearch() {
      if (EncryptUtility.localStorageDecrypt("CSProject") !== null && EncryptUtility.localStorageDecrypt("CSProject") !== undefined) {
        this.selectedProject = JSON.parse(EncryptUtility.localStorageDecrypt("CSProject"));
        this.projectList = JSON.parse(EncryptUtility.localStorageDecrypt("CSProjectData"));
      }
      if (EncryptUtility.localStorageDecrypt("CSBusiness") !== null && EncryptUtility.localStorageDecrypt("CSBusiness") !== undefined) {
        this.selectedBusiness = JSON.parse(EncryptUtility.localStorageDecrypt("CSBusiness"));
        this.businessList = JSON.parse(EncryptUtility.localStorageDecrypt("CSBusinessData"));
      }
      if (EncryptUtility.localStorageDecrypt("CSCountry") !== null && EncryptUtility.localStorageDecrypt("CSCountry") !== undefined) {
        this.selectedCountry = JSON.parse(EncryptUtility.localStorageDecrypt("CSCountry"));
        this.countryList = JSON.parse(EncryptUtility.localStorageDecrypt("CSCountryData"));
      }
      if (EncryptUtility.localStorageDecrypt("CSWorkflow") !== null && EncryptUtility.localStorageDecrypt("CSWorkflow") !== undefined) {
        this.selectedWorkflow = JSON.parse(EncryptUtility.localStorageDecrypt("CSWorkflow"));
        this.workflowList = JSON.parse(EncryptUtility.localStorageDecrypt("CSWorkflowData"));
      }
      if (
        this.selectedProject.length !== 0 ||
        this.selectedBusiness.length !== 0 ||
        this.selectedCountry.length !== 0 ||
        this.selectedWorkflow.length !== 0
      ) {
        this.filterSearch();
      }
    },
    //Clear Search
    clearSearch() {
      EncryptUtility.localStorageRemoveItem("CSProject");
      EncryptUtility.localStorageRemoveItem("CSProjectData");
      EncryptUtility.localStorageRemoveItem("CSBusiness");
      EncryptUtility.localStorageRemoveItem("CSBusinessData");
      EncryptUtility.localStorageRemoveItem("CSCountry");
      EncryptUtility.localStorageRemoveItem("CSCountryData");
      EncryptUtility.localStorageRemoveItem("CSWorkflow");
      EncryptUtility.localStorageRemoveItem("CSWorkflowData");
      this.selectedProject = [];
      this.selectedBusiness = [];
      this.selectedCountry = [];
      this.selectedWorkflow = [];
      this.configSourcingData = [];
      this.totalRecords = 0;
      this.search = "";
      this.lpnText = "";
      this.lpnNum = "";
      this.dropOffLPNDialog = false;
      this.userAssignedLPN = "";
      this.stagingLocationLPN = "";
      this.dropLPN = false;
      this.$refs.configurationSourcing.resetValidation();
      this.getBreadCrumbLPN();
    },
    //Breadcrumb Data
    async getBreadCrumbLPN() {
      let lpnStatus = await AddFavourite.getLPNDetails(this.userId);
      this.lpnText = lpnStatus[0]?.lpn_info;
      this.lpnNum = lpnStatus[0]?.lpn;
      this.lpnKey = this.lpnNum.replace(/-/g, "");
      if (lpnStatus[0]?.lpn !== "" && lpnStatus[0]?.lpn !== null) {
        this.dropLPN = true;
        this.userAssignedLPN = lpnStatus[0]?.lpn;
      }
    },
    quickSearch() {
      if (this.$refs.configurationSourcing.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        this.axios
          .get(`wc/source_config_quick_search?user_id=${this.userId}&search=${this.search}`)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let responseData = response.data.body;
              if (responseData.length !== 0) {
                const newArr = responseData.map((obj) => {
                  return {
                    ...obj,
                    relativetime: Utility.displayDateFormat(obj.relativetime),
                  };
                });
                this.configSourcingData = newArr;
                this.totalRecords = newArr?.length;
              } else {
                this.configSourcingData = [];
                this.totalRecords = 0;
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: "No results found based on the criteria",
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            this.totalRecords = 0;
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          });
      }
    },
    filterSearch() {
      if(
        this.selectedProject?.length === 0 && 
        this.selectedBusiness?.length === 0 &&
        this.selectedCountry?.length === 0 && 
        this.selectedWorkflow?.length === 0
      ) {
        this.configSourcingData = [];
        this.totalRecords = 0;
        EncryptUtility.localStorageRemoveItem("CSProject");
        EncryptUtility.localStorageRemoveItem("CSProjectData");
        EncryptUtility.localStorageRemoveItem("CSBusiness");
        EncryptUtility.localStorageRemoveItem("CSBusinessData");
        EncryptUtility.localStorageRemoveItem("CSCountry");
        EncryptUtility.localStorageRemoveItem("CSCountryData");
        EncryptUtility.localStorageRemoveItem("CSWorkflow");
        EncryptUtility.localStorageRemoveItem("CSWorkflowData");
      } else {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let json = JSON.stringify({
          projkey_list: this.selectedProject,
          bukey_list: this.selectedBusiness,
          country_list: this.selectedCountry,
          wf_list: this.selectedWorkflow,
        });
        let obj = {
          userid: this.userId,
          json: json,
        };
        this.axios
          .post("wc/source_config_filter_search", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let responseData = response.data.body;
              if (responseData.length !== 0) {
                const newArr = responseData.map((obj) => {
                  return {
                    ...obj,
                    relativetime: Utility.displayDateFormat(obj.relativetime),
                  };
                });
                this.configSourcingData = newArr;
                this.totalRecords = newArr?.length;
                if (this.totalRecords > 1) {
                  if (this.selectedProject.length !== 0) {
                    EncryptUtility.localStorageEncrypt("CSProject", JSON.stringify(this.selectedProject));
                    if (this.projectList.length !== 0) {
                      EncryptUtility.localStorageEncrypt("CSProjectData", JSON.stringify(this.projectList));
                    }
                  }
                  if (this.selectedBusiness.length !== 0) {
                    EncryptUtility.localStorageEncrypt("CSBusiness", JSON.stringify(this.selectedBusiness));
                    if (this.businessList.length !== 0) {
                      EncryptUtility.localStorageEncrypt("CSBusinessData", JSON.stringify(this.businessList));
                    }
                  }
                  if (this.selectedCountry.length !== 0) {
                    EncryptUtility.localStorageEncrypt("CSCountry", JSON.stringify(this.selectedCountry));
                    if (this.countryList.length !== 0) {
                      EncryptUtility.localStorageEncrypt("CSCountryData", JSON.stringify(this.countryList));
                    }
                  }
                  if (this.selectedWorkflow.length !== 0) {
                    EncryptUtility.localStorageEncrypt("CSWorkflow", JSON.stringify(this.selectedWorkflow));
                    if (this.workflowList.length !== 0) {
                      EncryptUtility.localStorageEncrypt("CSWorkflowData", JSON.stringify(this.workflowList));
                    }
                  }
                } else {
                  EncryptUtility.localStorageRemoveItem("CSProject");
                  EncryptUtility.localStorageRemoveItem("CSProjectData");
                  EncryptUtility.localStorageRemoveItem("CSBusiness");
                  EncryptUtility.localStorageRemoveItem("CSBusinessData");
                  EncryptUtility.localStorageRemoveItem("CSCountry");
                  EncryptUtility.localStorageRemoveItem("CSCountryData");
                  EncryptUtility.localStorageRemoveItem("CSWorkflow");
                  EncryptUtility.localStorageRemoveItem("CSWorkflowData");
                }
              } else {
                this.configSourcingData = [];
                this.totalRecords = 0;
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: "No results found based on the criteria",
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            this.totalRecords = 0;
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          });
      }
    },
    //Source button click event
    sourceWorkflow(item) {
      this.$router.push({
        name: "configurationSourcingDetails",
        params: {
          soKey: btoa(item.so_id.toString()),
        },
      });
    },
    vacateWorkflow(item) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get(`wc/source_config_exit?user_id=${this.userId}&line_id=${item.line_id}`)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.filterSearch();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          this.totalRecords = 0;
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    takeWorkflow(item) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get(`wc/source_config_take?user_id=${this.userId}&line_id=${item.line_id}`)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.filterSearch();
            this.sourceConfigLoadSourcedLine();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          this.totalRecords = 0;
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    //Source Configuration Load Sourced Line
    sourceConfigLoadSourcedLine() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get(`wc/source_config_load_sourcedline?user_id=${this.userId}`)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            if (response.data.body.message !== "NA" && response.data.body.message !== null) {
              let responseData = JSON.parse(response.data.body.message);
              this.$router.push({
                name: "configurationSourcingDetails",
                params: {
                  soKey: btoa(responseData[0].so_key.toString()),
                },
              });
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          this.totalRecords = 0;
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    //Drop Off LPN
    lpnDropOff() {
      if (this.$refs.stagingLocationCheckForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        this.axios
          .get(`wc/source_config_validate_dropoff_lpn?user_key=${this.userId}&bin=${this.stagingLocationLPN}`)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.getSourceConfigLineKeys();
              this.closeDropLPNDialog();
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              this.stagingLocationLPN = "";
              this.$refs.stagingLocationCheckForm.resetValidation();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            this.stagingLocationLPN = "";
            this.$refs.stagingLocationCheckForm.resetValidation();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Get Source Configuration Line Keys
    async getSourceConfigLineKeys() {
      let data = await usbServices.sourceConfigLineKeys("get", this.userId, this.lpnKey);
      if (data.message !== "NA") {
        this.lineKeys = [];
        this.lineKeys = data;
        this.getSourceConfigBTOPrint();
      }
    },
    //Get Source Configuration BTO Print
    getSourceConfigBTOPrint() {
      for (let i = 0; i < this.lineKeys.length; i++) {
        if (this.lineKeys[i]?.sot_line_key !== undefined) {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          this.axios
            .get("usb/sourcing_configuration_kits_bto_print_html?user_id=" + this.userId + "&line_id=" + this.lineKeys[i]?.sot_line_key)
            .then((response) => {
              if (response.status == 200) {
                if (
                  EncryptUtility.localStorageDecrypt("defaultName") !== undefined &&
                  EncryptUtility.localStorageDecrypt("defaultName") !== null &&
                  EncryptUtility.localStorageDecrypt("defaultName") !== ""
                ) {
                  Utility.printZPLPDF(response.data.body.message, EncryptUtility.localStorageDecrypt("defaultName"));
                }
                this.resetFunction();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                var Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              var Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        }
      }
    },
    //Close Drop Off LPN Dialog
    closeDropLPNDialog() {
      this.dropOffLPNDialog = false;
      this.stagingLocationLPN = "";
      this.$refs.stagingLocationCheckForm.resetValidation();
    },
    //To capture printer details once saved
    printerDetails(labelPrinter) {
      if (!labelPrinter) {
        this.printDisable = false;
        this.printerConfigured = false;
      } else {
        this.printDisable = true;
        this.printerConfigured = true;
      }
    },
    //To add or remove Favourite issue
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
    PrinterDetails,
  },
};
